import { Resolution } from "@grindex-common/helpers/Resolution.class";
import { $elementChild } from "@grindex-common/helpers/elements";
import { constants } from "./Accordion.constants";

const largeBPPages = [
	"product-page",
	"blog-home-page",
	"blog-detail-page",
	"brand-content-page",
	"content-author-page",
	"application-detail-page",
	"application-tier-page",
	"event-detail-page",
	"content-detail-page",
	"video-media-page",
];

// If doing any modifications to this class, verify that it does not
// break anything in the accordion functionality in app.js
class Expandable {
	constructor($component) {
		const accordionParent = $component.closest("[data-accordion-breakpoint]");
		this.isExpandable = $component.dataset.expandable === "true";
		this._$component = $component;
		this._$trigger = $elementChild($component, "accordion-trigger");

		if (!this._$trigger) {
			this._$trigger = $elementChild($component.parentElement, "accordion-trigger");
		}

		this.isMobileAccordion = accordionParent ? true : false;
		this.accordionBreakPoint = this.isMobileAccordion ? accordionParent.dataset.accordionBreakpoint : "";

		this.resolution = new Resolution();
	}

	isValid() {
		return this._$trigger && this._$component;
	}

	shouldSlide() {
		if (!this.isValid()) {
			return false;
		}

		const breakpoint = this.getAccordionBreakpoint();

		// If accordion conditions are satisfied, Accordion.js will handle it
		return (this._$component && !this.isAccordionChild) || this.resolution.isLargerThan(breakpoint);
	}

	shouldShowAsAccordion() {
		return this.isValid() && this.isMobileAccordion && this.isBelowAccordionBreakPoint();
	}

	isBelowAccordionBreakPoint() {
		if (!this.isMobileAccordion) {
			return false;
		}

		return this.resolution.isLessThan(this.resolution.devices[this.accordionBreakPoint]);
	}

	getAccordionBreakpoint() {
		const hasBreakPointClass = [...document.body.classList].some((cssClass) => {
			return largeBPPages.includes(cssClass);
		});

		return hasBreakPointClass ? this.resolution.desktopLarge.min : this.resolution.desktop.min;
	}

	toggle() {
		if (!this.shouldSlide) {
			return;
		}

		if (!this.shouldSlide() || this.shouldShowAsAccordion()) {
			return;
		}

		if (this._$component.classList.contains(constants.CLASS_ACTIVE)) {
			this.collapseContent();
		} else {
			this.expandContent();
		}
	}

	isExpanded() {
		return this._$component.classList.contains(constants.CLASS_ACTIVE);
	}

	setActive(active) {
		if (active) {
			this._$component.classList.add(constants.CLASS_ACTIVE);
		} else {
			this._$component.classList.remove(constants.CLASS_ACTIVE);
		}
	}

	expandContent() {
		this.setActive(true);

		this._$component.classList.add(constants.CLASS_ACTIVE);
	}

	collapseContent() {
		this.setActive(false);

		this._$component.classList.remove(constants.CLASS_ACTIVE);
	}
}

export { largeBPPages, Expandable };
